<router-outlet></router-outlet>
<nz-spin nzSimple [nzSize]="'large'" *ngIf="isLoading" class="page-loading"></nz-spin>
